<template>
  <div>
    <title>店员管理</title>
    <section class="mainPart">
      <!--S 检索-->
      <el-form :inline="true" :model="distributeForm">
          <el-form-item label="关键词">
              <el-input clearable v-model="distributeForm.keyword" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" plain @click="getShowDepotDlog('add',0)">新增</el-button>
          </el-form-item>
      </el-form>
      <!--E 检索-->
      <!-- S 列表 -->
      <div class="gsListTable individualiz">
        <el-form :model="searchGLForm" inline size="medium">
          <el-form-item class="borderline borderNone">
            <em class="greyColor">状态</em>
            <el-checkbox-group v-model="searchGLForm.status" @change="statusChange" >
              <el-checkbox label="1">启用</el-checkbox>
              <el-checkbox label="0">禁用</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <el-table class="comTable orderTable" v-loading="loading" ref="gsTable" :data="payRecordList" border :maxHeight="tableHeight">
          <el-table-column label="序号" type="index" fixed width="80"></el-table-column>
          <el-table-column label="店员账号" fixed sortable prop="username" min-width="120">
            <template slot-scope="scope">
              <p class="textFl pr70" :title="scope.row.username">{{scope.row.username ||'--'}}</p>
            </template>
          </el-table-column>
          <el-table-column label="联系人" min-width="120" sortable prop="mobile">
            <template slot-scope="scope">
              <p class="textFl pr70" :title="scope.row.linkman">{{scope.row.linkman ||'--'}}</p>
              <small class="commonNum textFl greyColor" :title="scope.row.mobile">{{scope.row.mobile || scope.row.tel}}</small>
            </template>
          </el-table-column>
          <el-table-column label="详细地址" min-width="200">
            <template slot-scope="scope">
                <div class="pr70">
                    <p class="textFl">{{scope.row.province}}{{scope.row.city}}{{scope.row.district}}</p>
                    <small class="textFl greyColor" :title="scope.row.addrdet">{{scope.row.addrdet ||'--'}}</small>
                </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" sortable prop="status" min-width="120">
            <template slot-scope="scope">
              <el-switch :value="scope.row.status? true : false" @change="handleStatus(scope.row,scope.row.status)" :width="45" class="isSwitch" :active-text="scope.row.status?'启':'禁'"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
              <template slot-scope="scope">
                <p class="handle">
                  <span class="detailA" title="详情" @click="getShowDepotDlog('detail',scope.row.flowcode)"><i class="icondetails"></i></span>
                  <span title="编辑" @click="getShowDepotDlog('edit',scope.row.flowcode)"><i class="iconedit"></i></span>
                </p>
              </template>
          </el-table-column>
            <template slot="empty">
                <div class="noData"><span>暂无数据</span></div>
            </template>
        </el-table>
      </div>
      <!-- E 列表 -->
      <!-- S 分页 -->
        <Page :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam"></Page>
      <!-- E 分页 -->
    </section>
  </div>
</template>
<script>
import Api from '@/apis/api';
import { Message, MessageBox } from "element-ui";
export default {
  name: 'ShopSalesman',
  data () {
    return {
      loading:false,
      pageTotal:0, //总数
      currentPage:1, // 页数
      pageSize:30, // 条数
      sellType:this.$route.params.sellType,//销售类型：0：自己；1：有二级分销商
      //检索
      distributeForm: {
        keyword: "", //关键词
      },
      searchGLForm: {
        status: [],//状态
      },
      payRecordList:[],
      tableHeight: window.innerHeight*.8, //表格动态高度
      operate:'',//操作，add:新增，edit:编辑，detail:详情
      paths:'',
    }
  },
  watch:{
    $route(to,from){
          this.paths = from
           this.sellType=this.$route.params.sellType;//接受路由带过来的变量，控制元素显隐
      },
  },
  activated(){
    setTimeout(()=>{
      if(this.paths.name=='新增店员1'&&this.paths.params.operate!='add'){
             this.getFlowList();
      }else{
          this.distributeForm={
            keyword: "", //关键词
          };
          this.searchGLForm={
            status: [],//状态
          };
          this.currentPage=1;
          this.getFlowList();
      }
    },100)
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"],resolve),
  },
  methods: {
    //切换状态
    handleStatus(row,val){
      let valTxt = '';
      let status = 0;
      if(!val){
          valTxt = '启用';
          status = 1;
      }else{
          valTxt = '禁用';
          status = 0;
      }
      MessageBox.confirm(`确定${valTxt}当前店员账号吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
            ucodes:row.flowcode,
            status:status
        }
       Api.UPDATEFLOWSTATUS(params).then((res) => {
            if(res.data.status == '200'){
                this.$message.success(`${valTxt}成功`);
                this.getFlowList();
            }else{
                this.$message.error(res.data.message)
            }
        })
      }).catch(() => {});
    },
    // 进入门店编辑、详情页面
    getShowDepotDlog(operate,flowcode){
        this.operate = operate;
        this.$router.push({
          name:'新增店员1',
          path:'/ShopAddsalesmandy',
          params:{
            operate:operate,
            flowcode:flowcode
          }
        })
        // this.depotVisible = true;
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
      this.tableHeight = window.innerHeight - tbHeight - 130;
    },
    nowPageParam(val,vals){
      this.pageSize = val;
      this.currentPage = vals;
      this.getFlowList();
    },
    search(){
      this.currentPage = 1;
      this.getFlowList();
    },
    statusChange(){
      if(this.searchGLForm.status.length > 1) {
          this.searchGLForm.status.splice(0,1)
      }
      this.currentPage = 1;
      this.getFlowList();
    },
    getFlowList(){
      this.loading = true;
      let param = {
        flowname:this.distributeForm.keyword,
        objtype:6,
        pageparam:{
          pagesize: this.pageSize, //每页条数
          currentpage: this.currentPage, //当前页数
        }
      }
      if(this.searchGLForm.status[0]){
        param.status =  Number(this.searchGLForm.status[0]);
      }
      Api.GET_FLOWLIST(param).then(res =>{
        if(res.data.status=="200"){
            this.loading = false;
            this.payRecordList = res.data.data;
            this.pageTotal = res.data.pagebean.totalnum;
            this.$refs.gsTable.bodyWrapper.scrollTop = 0;
        }else {
            this.loading = false;
            this.pageTotal =0;
            this.payRecordList =[];
        }
      })
    }
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted () {
    if (this.$route) {
        this.sellType=this.$route.params.sellType;//接受路由带过来的变量，控制元素显隐
    }
    this.getFlowList();
    //在dom渲染之后
    setTimeout(()=>{
      this.getHeight();
    },200)
  },
  destroyed(){
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
@import '../Css/style.css';
.mainPart {padding: 20px; height: calc(100% - 50px);}
.pr70 {padding-right: 70px;}
.comTable .el-dropdown-link{
    cursor: pointer;
    color: var(--main-color);
}
</style>



// WEBPACK FOOTER //
// src/views/ManageFolder/ManageJsz/ShopSalesmandy.vue